import Component from '../abstracts/Component';

export default class JournalHeroComponent extends Component {
  get SELECTORS() {
    return {
      title: '[data-title]',
      titleLine: '[data-title-line]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.title = this.$component.querySelector(this.SELECTORS.title);
    this.titleLines = this.$component.querySelectorAll(this.SELECTORS.titleLine);
    this.typeText = [];
    // variables for typewriting animation
    this.speed = 50;
    this.index = 0;
    this.arrLength = 0;
    this.scrollAt = 20; // start scrolling up at this many lines (try to delete this)
    this.textPos = 0; // initialise text position
    this.contents = ''; // initialise contents variable
    this.row = null; // initialise current row
  }

  setHeight() {
    let titleHeight = this.title.offsetHeight;
    this.title.style.height = `${titleHeight}px`;
  }

  getText() {
    this.titleLines.forEach(line => {
      this.typeText.push(line.innerHTML);
    });
    this.arrLength = this.typeText[0].length;
    this.animateTitle();
  }

  animateTitle() {
    this.contents = ' ';
    this.row = Math.max(0, this.index - this.scrollAt);
    while (this.row < this.index) {
      this.contents += this.typeText[this.row++] + '<br />';
    }
    this.title.innerHTML =
      this.contents + this.typeText[this.index].substring(0, this.textPos);
    if (this.textPos++ == this.arrLength) {
      this.textPos = 0;
      this.index++;
      if (this.index != this.typeText.length) {
        this.arrLength = this.typeText[this.index].length;
        setTimeout(() => this.animateTitle(), 0);
      }
    } else {
      setTimeout(() => this.animateTitle(), this.speed);
    }
  }

  render() {
    this.log('Rendering...');
    if (this.titleLines) {
      this.setHeight();
      this.getText();
    }
  }
}
